import { useRoute, useRouter } from "vue-router";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import { onMounted, getCurrentInstance, reactive } from "vue";
import moment from "moment";
import { freightUnitTypeMap, invoiceSuccessList } from "@/util/type";
import { phoneDesc } from "@/util";
export default {
  name: "InvoiceHistoryDetail",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      amount: "",
      bankNo: "",
      forwarderName: "",
      internalRequestNo: "",
      invoiceItems: "",
      invoiceNo: "",
      invoiceTime: "",
      name: "",
      openBank: "",
      list: [],
      taxNo: "",
      status: "",
      type: "",
      workAddress: "",
      page: 1,
      size: 10,
      total: 0
    });
    onMounted(() => {
      selectWebServiceFeeInvoiceRecordInfo();
    });
    const selectWebServiceFeeInvoiceRecordInfo = async () => {
      const {
        amount,
        bankNo,
        forwarderName,
        internalRequestNo,
        invoiceItems,
        invoiceNo,
        invoiceTime,
        name,
        openBank,
        serviceFeeInvoiceOrderRecordVOPage: {
          records,
          size,
          total,
          current
        },
        taxNo,
        status,
        type,
        workAddress
      } = await globalProperties.$api.selectWebServiceFeeInvoiceRecordInfo({
        serviceFeeInvoiceRequestId: route.query.serviceFeeInvoiceRequestId,
        page: data.page,
        size: data.size
      });
      data.list = records;
      data.page = current;
      data.total = total;
      data.size = size;
      data.amount = amount;
      data.bankNo = bankNo;
      data.forwarderName = forwarderName;
      data.internalRequestNo = internalRequestNo;
      data.invoiceItems = invoiceItems;
      data.invoiceNo = invoiceNo;
      data.invoiceTime = invoiceTime;
      data.name = name;
      data.taxNo = taxNo;
      data.openBank = openBank;
      data.status = status;
      data.type = type;
      data.workAddress = workAddress;
    };
    const currentChange = page => {
      data.page = page;
      data.size = 10;
      selectWebServiceFeeInvoiceRecordInfo();
    };
    return {
      currentChange,
      data,
      zhCn,
      invoiceSuccessList,
      moment,
      freightUnitTypeMap,
      phoneDesc
    };
  }
};